//
//
//
//
//
//
//
//

export default {
  components: {},
  props: ['market', 'event', 'cols', 'inverse'],
  computed: {
    grid() {
      if (this.cols && this.cols > 2) {
        return 'grid-cols-3'
      }
      if (_.get(this.market, 'outcomes.length') > 2) {
        return 'grid-cols-3'
      }
      return 'grid-cols-2'
    }
  },
  data() {
    return {
      layouts: {5498: []},
      visible: false,
      loading: true,
      balance: null
    }
  },
  mounted() {
    if (this.initiallyHidden) {
      this.visible = false
    } else {
      this.visible = true
    }
  },
  methods: {
    show() {
      this.visible = true
    },
    hide() {
      this.visible = false
    }
  }
}
